import axios from 'axios';

import { getV2RootUrl, publicAxiosHeaderV2 } from 'common/helpers/apiHelper';

export const listProducts = (slug, cartId, customerId, qString, page) => {
  const params = [];

  if (slug) {
    params.push(`collectionSlug=${slug}`);
  }
  if (cartId) {
    params.push(`cartId=${cartId}`);
  }
  if (customerId) {
    params.push(`customerId=${customerId}`);
  }
  if (qString) {
    params.push(qString);
  }
  if (page) {
    params.push(`page=${page}`);
  }

  const queryString = params.length > 0 ? `?${params.join('&')}` : '';

  return axios.get(
    `${getV2RootUrl()}/product/for-web${queryString}`,
    publicAxiosHeaderV2()
  );
};

export const getProduct = (slug, cartId, customerId) => {
  let urlString = '';
  if (cartId) {
    urlString += `&cartId=${cartId}`;
  }
  if (customerId) {
    urlString += `&customerId=${customerId}`;
  }
  return axios.get(
    `${getV2RootUrl()}/product/slug/${slug}/for-web?${urlString}`,
    publicAxiosHeaderV2()
  );
};
